import React, { Component } from "react";
import { connect } from "react-redux";
import { QRTrackActions } from "../../actions/index.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import "../../../src/style/QRTrackProgress.css"
//import truckIcon from "../../assets/images/truck-icon.png";

class QRTrack extends Component {
  constructor(props) {
    super(props);
    this.truckRef = React.createRef();
    this.reportRef = React.createRef();
    this.state = {
      scanTxt: "",
      truckVisible: true,
      visibleSteps: 0,
    };
  }
  generatePDF = () => {
    const input = this.reportRef.current;
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      // Watermark text: AVW

pdf.setFontSize(40);
pdf.setTextColor(230, 230, 230); // light gray
pdf.setFont("helvetica", "bold");

const spacingX = 80;
const spacingY = 60;

for (let y = -pdf.internal.pageSize.getHeight(); y < pdf.internal.pageSize.getHeight() * 2; y += spacingY) {
  for (let x = -pdf.internal.pageSize.getWidth(); x < pdf.internal.pageSize.getWidth() * 2; x += spacingX) {
    pdf.text("AVW", x, y, { angle: 45 });
  }
}

      // Add captured image
      const imgProps = pdf.getImageProperties(imgData);
      const contentHeight = (imgProps.height * pdfWidth) / imgProps.width;
      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, contentHeight);

      pdf.save(`QR_Tracking_Report_${Date.now()}.pdf`);
    });
  };

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };
  componentDidMount() {
    if (this.truckRef.current) {
      this.truckRef.current.addEventListener("animationend", this.handleTruckEnd);
    }
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.scanInfo !== prevProps.scanInfo &&
      this.props.scanInfo?.TIDproducts?.[0]?.ResponseCode === "200"
    ) {
      this.setState({ visibleSteps: 0, truckVisible: true }, () => {
        setTimeout(() => this.setState({ visibleSteps: 1 }), 0);        // Step 1 immediately
        setTimeout(() => this.setState({ visibleSteps: 2 }), 400);     // Step 2 after 1s
        setTimeout(() => this.setState({ visibleSteps: 3 }), 800);     // Step 3 after 2s
      });
    }
  }
  
  componentWillUnmount() {
    if (this.truckRef.current) {
      this.truckRef.current.removeEventListener("animationend", this.handleTruckEnd);
    }
  }
  handleTruckEnd = () => {
    console.log("Animation Ended – hiding truck");
    this.setState({ truckVisible: false });
  };
  
  ScanItem = (e) => {
    if (e.key === "Enter") {
      let qr = e.target.value.trim();
      let invoiceNo=e.target.value.trim();
      if (/^\d+$/.test(qr)) {
        this.props.GetScanInfo(qr);
      } else {
        this.props.GetScanInfo(invoiceNo);
      }
      this.setState({ scanTxt: "" });
    }
  };

  // ScanItem = (e) => {
  //   if (e.key === "Enter") {
  //     const input = e.target.value.trim();
      
  //     if (input.includes("|")) {
  //       const [qr, invoiceNo] = input.split("|").map(s => s.trim());
  //       if (qr && invoiceNo) {
  //         this.props.GetScanInfo({ qr, invoiceNo });
  //       }
  //     } else if (/^\d+$/.test(input)) {
  //       this.props.GetScanInfo({ qr: input, invoiceNo: "" });
  //     } else {
  //       this.props.GetJourney(input);
  //     }
  //     this.setState({ scanTxt: "" });
  //   }
  // };
  
  render() {
    const { journeyList = [], scanInfo } = this.props;
    const scanData = scanInfo?.TIDproducts?.[0] || null;

    const data = {
      qrCode: scanData?.QR || "N/A",
      location: scanData?.registerdlocation || "N/A",
      activatedBy: scanData?.ActivatedBy || "N/A",
      activatedDate: scanData?.ActivationDate || "N/A",
      contractorName: scanData?.ContractorName || "N/A",
      dealerName:scanData?.DealerName||"N/A",
      seqNo:scanData?.SeqNo|| "N/A",
      issueDate: scanData?.IssueDate || "N/A",
      invoiceNumber: scanData?.InvoiceNo || "N/A",
      contractor: scanData?.Mechanic || "a registered contractor",
      scanDate: scanData?.ScanDate ? new Date(scanData.ScanDate).toLocaleDateString() : "an unknown date",
      verificationDate:scanData?.VerificationDate ?new Date(scanData.VerificationDate).toLocaleDateString(): "an unkown date",
      registeredLocation: `${scanData?.registerdlocation || "an unknown city"}, ${scanData?.ScanState || "state unknown"}`,
      scanCity: `${scanData?.ScanCity || "unknown"}`,
    };

    return (
      <div className="container py-3 qr">
        <div className="row justify-content-center">
          <div className="col-md-6">
            <div className="card card-outline-secondary">
              <div className="card-header">
                <h3 className="mb-0">
                  <b>QR Code Tracking Report</b>                  
                </h3>
              </div>
              <div className="card-body">
                <input
                  onChange={this.handleChange}
                  name="scanTxt"
                  value={this.state.scanTxt}
                  type="search"
                  autoComplete="off"
                  className="form-control"
                  id="scan"
                  onKeyDown={this.ScanItem}
                  autoFocus
                />
              </div>
            </div>

            {scanData && scanData.ResponseCode === "200" && (
              <div className="card card-outline-secondary mt-4">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">Tracking Details</h5>
                  <button className="btn btn-sm btn-success" onClick={this.generatePDF}>
                    Download
                  </button>
                </div>
                <div className="card-body "ref={this.reportRef}>
                  <div className="progress-wrapper">
                  {this.state.truckVisible && (
                <div className="truck-animation">
                    <div className="truck" ref={this.truckRef}  onAnimationEnd={this.handleTruckEnd} />
                    </div>
                    )}
                  <div className="progress-container"
                  style={{
                    '--line-height': `${(this.state.visibleSteps - 1) * 90}px`, // grows as steps show
                  }}
                  >
                  {this.state.visibleSteps >= 1 && (
                    <div className="step completed">
                      <div className="step-icon">1</div>
                      <div className="step-content">
                        Activated against SeqNo <strong>{data.seqNo}</strong> at <strong>{data.location}</strong> warehouse by <strong>{data.activatedBy}</strong> on <strong>{data.activatedDate}</strong>
                      </div>
                    </div>
                      )}

                     {/* <div className="truck-animation">
                      <div className="truck"></div>
                    </div>  */}
                       
                   {/* <div className="truck-line">
                      <img src={truckIcon} className="truck-on-line" alt="Moving Truck" />
                    </div> */}
                     {this.state.visibleSteps >= 2 && (
                    <div className="step completed">
                      <div className="step-icon">2</div>
                      <div className="step-content">
                        Issued for <strong>{data.dealerName}</strong> on <strong>{data.issueDate}</strong> against invoice <strong>{data.invoiceNumber}</strong>
                      </div>
                    </div>
                        )}
                      {/* <div className="truck-animation">   
                       <div className="truck"></div> 
                    </div>  */}
                     {this.state.visibleSteps >= 3 && (
                    <div className="step completed">
                      <div className="step-icon">3</div>
                      <div className="step-content">
                        <strong>Authenticity Checked</strong> by <strong>{data.contractorName}</strong> on <strong>{data.verificationDate}</strong> at <strong>{data.scanCity}</strong>
                      </div>
                    </div>
                      )}
                  </div>
                  
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  console.log(state);
  const qrState = state.QRTrack || {};
  return {
    journeyList: qrState.journeyList || [],
    qrs: qrState.qrs || false,
    scanInfo: qrState.scanInfo || null,
    TIDproducts: qrState.TIDproducts || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetScanInfo: (data) => dispatch(QRTrackActions.GetScanInfo(data)),
    GetJourney: (data) => dispatch(QRTrackActions.GetJourney(data)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(QRTrack);